import type { HeadMetaDynamicTypes } from '@/types/HeadMeta'
import { useHeadMeta as useHeadMetaComposable } from './head/useHeadMeta'

export const useHeadMeta = (dynamic?: HeadMetaDynamicTypes) => {
    const route = useRoute()
    const { getHeadMeta, ...otherFunctions } = useHeadMetaComposable()
    const headMetaData = getHeadMeta(route, dynamic)

    useHead({
        title: headMetaData.title,
        titleTemplate: headMetaData.titleTemplate as ((title?: string) => string) | undefined,
        meta: headMetaData.meta,
        link: headMetaData.link,
        script: headMetaData.script
    })

    // Return the functions for pages that need them
    return {
        getHeadMeta,
        ...otherFunctions
    }
}
